const initialState = {
    theme: localStorage.getItem('theme') || 'orange'
};

export const Types = {
    SET_THEME: 'theme/SET_THEME',
    INIT_THEME: 'theme/INIT_THEME'
};

export const Actions = {
    setTheme: (theme) => ({
        type: Types.SET_THEME,
        payload: theme
    }),
    initTheme: () => ({
        type: Types.INIT_THEME
    })
};

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case Types.SET_THEME:
            localStorage.setItem('theme', action.payload);
            return {
                ...state,
                theme: action.payload
            };
        default:
            return state;
    }
};

export default reducer; 